import { createSelectorCreator } from 'reselect'

import memoize from 'utils/memoize'
import stats from './stats'

// export default createSelectorCreator(memoize)
let cache = {}
let n = 0
export default function createSelector(dependencies, fn, name) {
	if (!name) {
		name = '_noname_' + ++n
		// if (n === 75) debugger
	}
	let createSelector = cache[name]
	if (!createSelector) {
		createSelector = createSelectorCreator(memoize, {
			callback: time => {
				let s = stats(name)
				s.recomputations++
				s.time += time
			}
		  , size: 1
		})
		cache[name] = createSelector
	}
	return createSelector(dependencies, fn)
}



// WEBPACK FOOTER //
// ./src/utils/redux/createSelector.js